import { Plan, SubscriptionPlans } from './types';

export const firstLastNameValidationRule = {
    firstName: {
        presence: true,
        length: {
            minimum: 1,
            message: '^This field is required',
        },
    },
    lastName: {
        presence: true,
        length: {
            minimum: 1,
            message: '^This field is required',
        },
    },
};

export function getPlanDetails(plans: SubscriptionPlans, planCode: string) {
    return plans.monthly.find((plan) => plan.code === planCode) || plans.yearly.find((plan) => plan.code === planCode);
}

export function getDefaultPlan(plans: SubscriptionPlans) {
    return plans.monthly.find((plan) => plan.settings.default);
}

export function getPlanSettings(plan: Plan) {
    return [
        {
            name: 'SEO Analysis',
            value: plan.settings.seo_analysis_limit,
            cl: 'value'
        },
        {
            name: 'Technical SEO Audit',
            value: 'Included',
            cl: 'value included'
        },
        {
            name: 'LLM Visibility Checker',
            value: plan.settings.allow_llm_visibility_checker ? 'Included' : 'Not included',
            cl: `value ${plan.settings.allow_llm_visibility_checker ? 'included' : 'not-included'}`
        },
        {
            name: 'AI Content Analysis',
            value: plan.settings.allow_ai_content_analysis ? 'Included' : 'Not included',
            cl: `value ${plan.settings.allow_ai_content_analysis ? 'included' : 'not-included'}`
        },
        {
            name: 'Weekly SEO score monitoring',
            value: plan.settings.max_tracked_websites,
            cl: 'value'
        },
        {
            name: 'Deep Analysis - Websites',
            value: plan.settings.dp_max_domains,
            cl: 'value'
        },
        {
            name: 'Deep Analysis - Monitored URLs',
            value: plan.settings.dp_max_urls,
            cl: 'value'
        },
        {
            name: 'Keyword position tracking',
            value: plan.settings.max_keywords,
            cl: 'value'
        },
        {
            name: 'Competitor SEO comparison',
            value: plan.settings.max_competitors,
            cl: 'value'
        },
        {
            name: 'Site uptime monitoring',
            value: plan.settings.max_monitored_regions,
            cl: 'value'
        },
        {
            name: 'Site speed monitoring',
            value: plan.settings.max_tracked_websites,
            cl: 'value'
        },
        {
            name: 'White Label Reports',
            value: plan.settings.allow_white_label_reports ? 'Included' : 'Not included',
            cl: `value ${plan.settings.allow_white_label_reports ? 'included' : 'not-included'}`
        },
        {
            name: 'Team members',
            value: (plan.settings.max_team_members as number) > 0 ? plan.settings.max_team_members : 'Not included',
            cl: `value ${(plan.settings.max_team_members as number) > 0 ? '' : 'not-included'}`
        },

    ];
}
